import React from "react";
import DisplayField from "../DisplayField";
import Contact from "./Contact";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import styles from "./BidEvent.css";

const Details = ({ event }) => (
  <div>
    <DisplayField group="details" field="jobStatus">
      <FormGroup className={styles.dataValuePair}>
        <ControlLabel className={styles.dataValuePairLabel}>
          Bid Status
        </ControlLabel>
        <FormControl.Static
          className={styles.dataValuePairValue}
          componentClass={"div"}
        >
          {event.bid.status ? event.bid.status.name : "N/A"}
        </FormControl.Static>
      </FormGroup>
    </DisplayField>

    <DisplayField group="details" field="customerName">
      <FormGroup className={styles.dataValuePair}>
        <ControlLabel className={styles.dataValuePairLabel}>
          Customer
        </ControlLabel>
        <FormControl.Static
          className={styles.dataValuePairValue}
          componentClass={"div"}
        >
          {event.bid.customer ? event.bid.customer.name : "N/A"}
        </FormControl.Static>
      </FormGroup>
    </DisplayField>

    {event.bid.contacts.length > 0 && (
      <DisplayField group="details" field="contact">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Contact
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            <Contact contact={event.bid.contacts[0]} />
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.bid.salesperson && (
      <DisplayField group="details" field="salesperson">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Salesperson
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.bid.salesperson.firstName} {event.bid.salesperson.lastName}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.bid.priorityNotes && (
      <DisplayField group="details" field="priorityNotes">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Priority Notes
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.bid.priorityNotes}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}
  </div>
);

export default Details;
